












import { Vue, Component } from 'vue-property-decorator';

import EmailPreview from '@/componentsV2/templates/EmailPreview/EmailPreview.vue';
import CustomerAcquisitionEmailPreview from '@/componentsV2/templates/CustomerAcquisitionEmailPreview/CustomerAcquisitionEmailPreview.vue';

@Component({
  components: {
    EmailPreview,
    CustomerAcquisitionEmailPreview
  }
})
export default class ActivationEmailPreviewEmail extends Vue {}
